/**
 * /frontend/src/features/analytics/components/peak/PeakHoursChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import HorizontalBarChart from '../charts/HorizontalBarChart';
import { toPeakTopHoursSeries } from '../../utils/chartDataTransformers';

/**
 * Peak hours bar chart.
 * @param {{topHours:any}} props
 * @returns {JSX.Element}
 */
const PeakHoursChart = ({ topHours }) => {
  const data = useMemo(() => toPeakTopHoursSeries(topHours), [topHours]);
  return (
    <ChartContainer title="Top Peak Hours" subtitle="Busiest hours over the selected lookback">
      <HorizontalBarChart data={data} xKey="label" yKey="value" />
    </ChartContainer>
  );
};

export default PeakHoursChart;
